import { FileDown } from "lucide-react";

import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

/**
 * Download the customer's quote PDF, exactly as they received it.
 *
 * This points at the same server-rendered endpoint the customer uses, so what
 * the team opens is the real document tied to that reference - not a rebuild
 * that could drift from it. The endpoint already returns
 * `Content-Disposition: attachment` with the T-TITE filename, so a plain link
 * is all that is needed: no blob juggling, and the browser handles it.
 *
 * Rendered as a link rather than a button so "open in new tab" and "save as"
 * behave the way people expect from a document.
 */
export const QuotePdfButton = ({ quoteRef, compact = false, className = "" }) => {
  if (!quoteRef) return null;

  return (
    <Button
      asChild
      variant="outline"
      size={compact ? "icon" : "default"}
      className={`${compact ? "h-9 w-9 shrink-0" : "h-10"} ${className}`}
    >
      <a
        href={api.quotePdfUrl(quoteRef)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`quote-pdf-download-${quoteRef}`}
        aria-label={`Download the quote PDF for ${quoteRef}`}
        title={`Download the quote PDF for ${quoteRef}`}
      >
        <FileDown className={compact ? "h-4 w-4" : "mr-2 h-4 w-4"} aria-hidden="true" />
        {compact ? null : "Download PDF"}
      </a>
    </Button>
  );
};
